import { message, Modal } from 'antd';
import React from 'react';

const MsgOrModalContext = React.createContext<{
  messageApi: ReturnType<typeof message.useMessage>[0];
  modalApi: ReturnType<typeof Modal.useModal>[0];
}>({
  messageApi: {} as ReturnType<typeof message.useMessage>[0],
  modalApi: {} as ReturnType<typeof Modal.useModal>[0],
});

function MsgOrModalProvider({ children }: { children: React.ReactNode }) {
  const [modalApi, contextModal] = Modal.useModal();
  const [messageApi, contextMessage] = message.useMessage();
  const contextValue = React.useMemo(() => ({
    messageApi,
    modalApi,
  }), [messageApi, modalApi]);

  return (
    <MsgOrModalContext.Provider value={contextValue}>
      {contextModal}
      {contextMessage}
      {children}
    </MsgOrModalContext.Provider>
  );
}

export default {};
export { MsgOrModalProvider, MsgOrModalContext };
